import { createFileRoute, Outlet, Navigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Layout } from '@/components/Layout';
import { OnboardingGate } from '@/components/OnboardingGate';
import { useAuthStore } from '@/stores/authStore';
import { canActAsInstructor } from '@/types';

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const { user, isAuthenticated, checkAuth, isInitializing } = useAuthStore();

  useEffect(() => {
    // Only call checkAuth if we're still initializing (haven't checked yet)
    if (isInitializing) {
      checkAuth();
    }
  }, [checkAuth, isInitializing]);

  if (isInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" />;
  }

  // Check if user can act as an instructor (primary role 'teacher' or has instructor.access)
  if (!canActAsInstructor(user)) {
    // Logout user who cannot instruct
    useAuthStore.getState().logout();
    return <Navigate to="/login" />;
  }

  return (
    <Layout teacherName={`${user.firstName || ''} ${user.lastName || ''}`.trim()}>
      <OnboardingGate />
      <Outlet />
    </Layout>
  );
}

